<template lang="pug">
.specie
  v-overlay(v-if="update", :value="overlay")
    v-progress-circular(indeterminate, size="64")
  v-card
    v-toolbar(color="primary", dark, flat)
      v-toolbar-title {{ update ? 'Actualizar' : 'Creación de' }} Especies
    .alert(v-if="messages_error_request")
      v-alert(border="top", color="red lighten-2", dark)
        ul
          li(v-for="message in messages_error_request") {{ message }}
    v-card-text
      ValidationObserver(
        ref="observer_specie_data",
        v-slot="{ validate, reset }"
      )
        v-form
          v-row
            v-col(cols="12", sm="12")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Nombre"
              )
                v-text-field(
                  v-model="specie.name",
                  label="Nombre",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", sm="12")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Identificador"
              )
                v-text-field(
                  v-model="specie.slug",
                  label="Identificador",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
    v-card-actions
      v-spacer
      v-btn(
        color="secondary",
        @click="createUpdateSpecie",
        :loading="loading",
        :disabled="loading"
      ) Guardar
</template>

<script>
import { mapState } from "vuex";
import utils from "@/resources/utils";
import specieAPI from "@/api/species";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío",
});

export default {
  async created() {
    if (this.update) {
      const response = await specieAPI.getSpecie(
        this.id_specie,
        this.auth_token
      );
      this.overlay = false;
      th;
      if (response.status) {
        this.specie.name = response.data.name;
        this.specie.slug = response.data.slug;
      } else {
        this.$swal({
          icon: "warning",
          title: response.data,
        });
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false,
    },
    id_specie: {
      type: Number | String,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      auth_token: (state) => state.auth.auth_token,
    }),
  },
  data() {
    return {
      messages_error_request: null,
      loading: false,
      overlay: true,
      specie: {
        name: null,
        slug: null,
      },
    };
  },
  methods: {
    async createUpdateSpecie() {
      this.messages_error_request = null;
      if (await this.$refs.observer_specie_data.validate()) {
        this.loading = true;
        if (this.update) {
          const response = await specieAPI.updateSpecie(
            this.id_specie,
            this.specie,
            this.auth_token
          );
          response.status
            ? await this.getSpecie(this.update)
            : this.$swal({
                icon: "success",
                title: response.data,
              });
        } else {
          const response = await specieAPI.createSpecie(
            this.specie,
            this.auth_token
          );
          response.status
            ? await this.getSpecie(this.update)
            : this.$swal({
                icon: "warning",
                title: response.data,
              });
        }
        this.loading = false;
      }
    },
    async getSpecie(action) {
      let title = "";
      action ? (title = "Actualizado") : (title = "Creado");
      this.$swal({
        title: `Especie ${title}`,
        icon: "success",
      });
      await this.$store.dispatch("species/getSpecies", {
        token: this.auth_token,
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
